import IntlMessages from './IntlMessages'

export default IntlMessages
